export const token =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VybmFtZSI6ImFkbWluIiwic3ViIjoxLCJyb2xlIjoiYWRtaW4iLCJpYXQiOjE2ODEzMTY1NzEsImV4cCI6MjE5OTcxNjU3MX0.8NvRsB49zFbr0DY8uR_Y0HJOrua6aImffjisJZdbhyA";
